import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const UNREAD_COMMENT_LOZENGE_VIEWED_KEY = 'unread-comment-lozenge-viewed';

export const localStorageProvider = createLocalStorageProvider('atl-issue-view-comment');

export const FIELD_TYPE_COMMENT = 'comment';
